import * as Yup from "yup";

const regExpOnlyLetters = /^[ñíóáéú a-zA-Z ]+$/;
const regExoOnlyNumbers = /^\d*$/;
const PhoneRegExp = /^[0-9 ]\d{6,9}$/;

export const validationModalYounger = Yup.object().shape({
  name: Yup.string()
    .matches(regExpOnlyLetters, "Por favor escriba solo letras.")
    .required("Campo obligatorio.")
    .max(20, "Máximo 20 caracteres."),
  lastNames: Yup.string()
    .matches(regExpOnlyLetters, "Por favor escriba solo letras.")
    .required("Campo obligatorio.")
    .max(20, "Máximo 20 caracteres."),
  documentNumber: Yup.string()
    .matches(regExoOnlyNumbers, "Por favor escriba solo números.")
    .required("Campo obligatorio.")
    .max(20, "Máximo 20 números."),
  numberPhone: Yup.string().matches(PhoneRegExp, "Por favor escriba solo números.").required("campo obligatorio."),
});
